import React, {PureComponent} from 'react';
import {FastField, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import {constants} from '@neosvoc/nv-platform-core-common';
import {FormattedMessage, injectIntl} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import Error from '../../../Error';

class NumberLogic extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {intl, id, field, form} = this.props;

        return (
            <div className="row">
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.operator`}><FormattedMessage {...messages.filters.operator} /></label>
                    <FastField id={`${id}.condition.operator`} name={`${field.name}.condition.operator`}
                        className={classNames('form-control custom-select',
                            {error: get(form.errors, `${field.name}.condition.operator`) && get(form.touched, `${field.name}.condition.operator`)})}
                        component="select">
                        <option value="">{intl.formatMessage(messages.filters.select)}</option>
                        <option value={constants.EDITOR_OPERATORS.GT}>{intl.formatMessage(messages.filters.operators.greaterThan)}</option>
                        <option value={constants.EDITOR_OPERATORS.LT}>{intl.formatMessage(messages.filters.operators.lessThan)}</option>
                        <option value={constants.EDITOR_OPERATORS.EQ}>{intl.formatMessage(messages.filters.operators.equal)}</option>
                    </FastField>
                    <ErrorMessage name={`${field.name}.condition.operator`}>
                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                    </ErrorMessage>
                </div>
                <div className="col">
                    <label className="col-form-label" htmlFor={`${id}.condition.value`}><FormattedMessage {...messages.filters.value} /></label>
                    <FastField id={`${id}.condition.value`} name={`${field.name}.condition.value`} type="number" step="any"
                        className={classNames('form-control',
                            {error: get(form.errors, `${field.name}.condition.value`) && get(form.touched, `${field.name}.condition.value`)})} />
                    <ErrorMessage name={`${field.name}.condition.value`}>
                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                    </ErrorMessage>
                </div>
            </div>
        );
    }
}

export default injectIntl(NumberLogic);
